import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css'; // Import your CSS file if you have one

const Scouting = () => {
  return (
    <div className="home-container">
      <header className="home-header">
        <h1>Practices</h1>
        <p>Select a page to visit:</p>
      </header>
      <main className="home-content">
        <nav className="home-nav">
          <ul>
            <li>
              <Link to="/create_internal_scouting">Create Internal Scouting</Link>
            </li>
            <li>
              <Link to="/view_internal_scouting">View Internal Scouting</Link>
            </li>
            <li>
              <Link to="/create_external_scouting">Create External Scouting</Link>
            </li>
            <li>
              <Link to="/view_external_scouting">View External Scouting</Link>
            </li>
            <li>
              <Link to="/home">Home</Link>
            </li>
            <li>
              <Link to="/">Log-out</Link>
            </li>
          </ul>
        </nav>
      </main>
    </div>
  );
}

export default Scouting;
